import { calculatePercentage, roundNumber } from "@app/shared/utils/math";
import { type GetSupplierQuestionnairesQuery } from "@generated/client/graphql";
import dayjs from "dayjs";

export const formatQuestionnaire = (
    questionnaire: NonNullable<
        GetSupplierQuestionnairesQuery["supplierQuestionnaires2"]
    >["list"][number],
) => ({
    ...questionnaire,
    sentDate: questionnaire.createdAt
        ? dayjs(questionnaire.createdAt).format("DD/MM/YYYY")
        : undefined,
    dueDate: questionnaire.deadline
        ? dayjs(questionnaire.deadline).format("DD/MM/YYYY")
        : undefined,
    progress: roundNumber(
        calculatePercentage(
            questionnaire.stats?.validated || 0,
            questionnaire.stats?.total || 0,
        ),
    ),
});

export function makeSupplierQuestionnaireLink({
    orgUname,
    supplierId,
    questionnaireId,
}: {
    orgUname: string;
    supplierId: string;
    questionnaireId: string;
}) {
    return `${window.origin}/o/${orgUname}/sup/${supplierId}/questionnaires/${questionnaireId}`;
}
